export const projects = [
  {
    id: 1,
    title: "TechNix | Digital Workshop",
    description: "The ultimate developer toolkit for digital document processing. Manipulate PDFs, convert images, remove backgrounds, and more with zero gravity and high precision.",
    technologies: ["React.js", "Next.js", "Tailwind CSS", "PDF-Lib", "Client-side JS"],
    link: null,
    demoLink: "https://www.technix.site/",
    image: "/images/technix.png"
  },
  {
    id: 2,
    title: "Weather Application",
    description: "A responsive weather app that provides real-time weather updates, forecasts, and location-based data using modern web technologies.",
    technologies: ["HTML", "CSS", "JavaScript", "Weather API"],
    link: "https://github.com/MuhammadGhyasAli/Sky-Gauge",
    demoLink: "https://muhammadghyasali.github.io/Sky-Gauge/",
    image: "https://raw.githubusercontent.com/MuhammadGhyasAli/Sky-Gauge/refs/heads/main/screenshot.png"
  },
  {
    id: 3,
    title: "Music Player",
    description: "A fully functional music player with playlist management, audio controls, and a sleek user interface for an immersive listening experience.",
    technologies: ["HTML", "CSS", "JavaScript", "Audio API"],
    link: "https://github.com/MuhammadGhyasAli/CodeAlpha/tree/main/Music%20player",
    demoLink: null,
    image: "/images/Music Player.png"
  },
  {
    id: 4,
    title: "Image Gallery",
    description: "An interactive image gallery featuring dynamic image display, filtering options, and smooth animations for enhanced user engagement.",
    technologies: ["HTML", "CSS", "JavaScript", "Responsive Design"],
    link: "https://github.com/MuhammadGhyasAli/CodeAlpha/tree/main/Image%20Gallery",
    demoLink: null,
    image: "/images/Image.png"
  },
  {
    id: 5,
    title: "Basic Calculator",
    description: "A clean and efficient calculator application supporting basic arithmetic operations with an intuitive interface and keyboard support.",
    technologies: ["HTML", "CSS", "JavaScript", "Math Operations"],
    link: "https://github.com/MuhammadGhyasAli/CodeAlpha/tree/main/Calculator",
    demoLink: null,
    image: "https://github.com/user-attachments/assets/8f8b2254-137b-42d9-b490-4a5e95010314"
  }
];

export const navLinks = [
  { href: '#about', label: 'About' },
  { href: '#projects', label: 'Projects' },
  { href: '#skills', label: 'Skills' },
  { href: '#contact', label: 'Contact' },
];

export const socialLinks = [
  {
    name: 'GitHub',
    url: 'https://github.com/MuhammadGhyasAli',
    icon: '/images/github.png',
  },
  {
    name: 'LinkedIn',
    url: 'https://www.linkedin.com/in/syed-ghyas-ali/',
    icon: '/images/linkedIn.png',
  },
  {
    name: 'WhatsApp',
    url: 'https://api.whatsapp.com/send?phone=923199664885&text=Hi Ghyas!',
    icon: '/images/number.png',
  },
];

export const skills = {
  "Frontend Development": [
    {
      name: "HTML5",
      level: "95%",
      icon: "/images/html5.svg"
    },
    {
      name: "CSS3",
      level: "90%",
      icon: "/images/css3.svg"
    },
    {
      name: "JavaScript",
      level: "85%",
      icon: "/images/javascript.svg"
    },
    {
      name: "Bootstrap",
      level: "88%",
      icon: "/images/bootstrap.svg"
    },
    {
      name: "Responsive Design",
      level: "92%",
      icon: "/images/responsive.svg"
    },
    {
      name: "React.js",
      level: "80%",
      icon: "/images/react.svg"
    },
  ],

  "Tools & Workflow": [
    {
      name: "Git/GitHub",
      level: "69%",
      icon: "/images/git.svg"
    },
    {
      name: "UI/UX Design",
      level: "70%",
      icon: "/images/ui-ux.svg"
    },
    {
      name: "Figma",
      level: "75%",
      icon: "/images/figma.svg"
    }
  ]
};
